export default __webpack_public_path__ + "static/media/manage-allocation-active.a17b7864.svg";